module.exports = "/static-assets/feed-ui/_next/static/images/HomepageHero-1e3bdf5e50afde3ac2a4e8da5650d63e.png";